<template>
  <div>
    <ContentWrapperControl class="mt-4">
      <div class="bg-white shadow rounded-lg p-6 text-sm leading-normal text-justify">
        <div class="pb-4">
          By participating in the fun run, you grant PAFCPIC permission to use your photos and videos for promotional purposes.
        </div>

        <!-- Horizontal line -->
        <hr class="my-4 border-t border-gray-300" />

        <!-- Checkbox -->
        <div class="mt-4 flex items-start">
          <input
            type="checkbox"
            id="consent"
            v-model="has_consented"
            class="mt-1 mr-3 custom-checkbox"
          />
          <label for="consent" class="text-sm">
            I grant PAFCPIC permission to use my photos and videos
          </label>
        </div>

        <!-- Proceed Button -->
        <div class="mt-6">
          <ButtonControl
            :disabled="!has_consented"
            @click="proceed"
          >{{ this.lang('lbl_0000033') }}</ButtonControl>
        </div>
      </div>
    </ContentWrapperControl>
  </div>
</template>

<script>
import ContentWrapperControl from './../../components/controls/ContentWrapperControl.vue';
import ButtonControl from './../../components/controls/ButtonControl.vue';
// import FunRun from '@/services/FunRun';
import mixin from './../../mixin.js';

export default {
  mixins: [mixin],
  components: {
    ContentWrapperControl,
    ButtonControl,
  },
  data() {
    return {
      has_consented: false,
    };
  },
  mounted() {
    this.$emit('shownavbar', {
      title: this.lang('lbl_0000324'),
      show: true,
      back: true,
    });
    this.$emit("nofooter", false);
  },
  methods: {
    proceed() {
      if (this.has_consented) {
        this.$router.push("/fun-run/summary");
        // console.log("User has consented to photo and video usage.");
        // this.$emit("showloader");
        
        // FunRun.register(this.$store.state.fun_run.registrants)
        //   .then((response) => {
        //     FunRun.sendEmail(response.data.data);
        //     this.$emit("success", this.lang("lbl_0000327"));
        //   })
        //   .catch((error) => {
        //     // console.log(error);
        //     this.$emit("error", error);
        //   }).finally(() => {
        //     this.$emit("hideloader");
        //     this.$router.push("/dashboard");
        //   });
      }
    },
  },
};
</script>

<style scoped>
.custom-checkbox {
  /* Green checkbox for all modern browsers */
  accent-color: #016B00;

  /* Fallback for older browsers */
  width: 1rem;
  height: 1rem;
  vertical-align: top;
}
</style>
